// extracted by mini-css-extract-plugin
export default {"videoContainer":"CharacterVideo_videoContainer__3MvGL","btnIsMuted":"CharacterVideo_btnIsMuted__KWMW9","soundOn":"CharacterVideo_soundOn__BwOIh"};